export default {
    MAX_INVESTMENT_PER_IDEA: "Maximum investment per recommendation",
    MAX_PERCENTAGE_OF_ADV_PER_IDEA: "Maximum percentage of Average Daily Volume per recommendation",
    MIN_INVESTMENT_PER_IDEA: "Minimum investment per recommendation"
}
